module.exports = __webpack_public_path__ + "static/media/landing-workorder.8ff79cfb.svg";